export var isIOption = function (value) {
    var _a;
    return ((_a = value) === null || _a === void 0 ? void 0 : _a.value) !== undefined;
};
//# sourceMappingURL=commonTypes.js.map